
export class PicturePack
{
    public Name: string = "";
    public Extension: string = "";
    public Original: string = "";
    public Normalized: string = "";
    public Thumbnail: string = "";
    public Mini: string = "";

    constructor(name: string, extension: string)
    {
        this.Name = name;
        this.Extension = extension;
    }
}
